export const hasExplicitSeekProgress = (seekProgress) => {
  if (typeof seekProgress === 'number') {
    return Number.isFinite(seekProgress);
  }
  if (typeof seekProgress === 'string') {
    return seekProgress.trim() !== '' && Number.isFinite(Number(seekProgress));
  }
  return false;
};
